import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import AppLayout from '@/components/layout/AppLayout';

export default function BillingSuccess() {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: ['my-workspaces'] });
  }, [queryClient]);

  return (
    <AppLayout>
      <div className="container mx-auto px-4 py-12 max-w-md text-center">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold mb-2">Thank you</h1>
        <p className="text-muted-foreground mb-6">
          Your subscription is set up. You can manage it anytime in Settings → Billing.
        </p>
        <Button asChild>
          <Link to="/app/settings/billing">Go to Billing</Link>
        </Button>
      </div>
    </AppLayout>
  );
}
